import { observer } from "mobx-react-lite";
import { useEffect } from "react";
import {
  updateAlarmCodeRule,
  useAlarmCodeRule,
} from "../../../../core/api/responsecenters/alarmcoderules";
import { ResponseCenterAlarmCodeRuleDetails } from "../../../../core/api/responsecenters/types";
import useTranslations from "../../../../core/i18n/useTranslations";
import useUser from "../../../../core/user/useUser";
import { notify } from "../../../../ui-lib/components/Alerts/Toast";
import { AlarmCodeRuleForm } from "./AlarmCodeRuleForm";
import { notifyApiErrors } from "../../../../core/helpers/helpers";

const EditAlarmCodeRuleModal = ({
  responseCenterId,
  alarmCodeRuleId,
  onEdit,
  closeModal,
}: {
  responseCenterId: string | number;
  alarmCodeRuleId: string | number;
  onEdit: () => void;
  closeModal: () => void;
}) => {
  const t = useTranslations();
  const { authenticatedRequest } = useUser();
  const { data, isLoading, isError } = useAlarmCodeRule(
    responseCenterId,
    alarmCodeRuleId,
  );

  useEffect(() => {
    if (isError) closeModal();
  }, [isError]);

  const labels = {
    title: t("AlarmReceptions:alarm_handling_alarm_code_rule_edit"),
    description: t(
      "AlarmReceptions:alarm_handling_alarm_code_rule_edit_description",
    ),
    submit: t("Common:save_changes"),
  };

  const onSubmit = async (values: ResponseCenterAlarmCodeRuleDetails) => {
    try {
      await updateAlarmCodeRule(
        responseCenterId,
        alarmCodeRuleId,
        values,
        authenticatedRequest,
      );

      notify({
        message: t(
          "AlarmReceptions:alarm_handling_alarm_code_rule_edit_success",
        ),
      });
      onEdit();
      closeModal();
    } catch (error: any) {
      notifyApiErrors(error.response?.data?.errors);
    }
  };

  return (
    <AlarmCodeRuleForm
      isOpen={!!alarmCodeRuleId}
      labels={labels}
      isLoading={isLoading}
      defaultValues={{ ...data }}
      onSubmit={onSubmit}
      onClose={closeModal}
    />
  );
};

export default observer(EditAlarmCodeRuleModal);
